// extracted by mini-css-extract-plugin
export default {"monthViewMargin":"MonthViewContainer_monthViewMargin__l2aq-"};